//This file provides the code for the hangman page of the website.

import getPuzzle from './hangman-request';
import Hangman from './hangman-class';
import {addFooter} from './footer';
import {addMenu} from './sliding-menu';
import {loadHeaderHTML} from './head-html-getter';

//Add the site footer to this page.
addFooter();

//Add the initially-hidden sliding menu to the page.
addMenu();

//Add the HTML to the page header.
loadHeaderHTML();

//Number of letters requested.
let letterCount;

//Number of missed guesses allowed.
const missedGuesses = 6;

//Variable to hold Hangman object.
let game;

//Function to update web page.
const updateDom = () => {
    //Clear puzzle element.
    document.querySelector('#puzzle').innerHTML = '';

    //Split puzzle into array.
    const letters = game.puzzle.split('');

    //Append each letter to puzzle div.
    letters.forEach((letter) => {
        const letterEl = document.createElement('span');
        letterEl.classList.add("letter");
        letterEl.textContent = letter;
        document.querySelector('#puzzle').appendChild(letterEl);
    });

    document.querySelector('#remaining_guesses').textContent = 
        game.statusMessage;
}

//Function to start a new game.
const startGame = async () => {
    try {
        letterCount = document.querySelector("#letter-number")
            .value;
        const puzzle = await getPuzzle(letterCount);
        game = new Hangman(puzzle, missedGuesses);
        updateDom();
    } catch (error) {
        //Clear anything in game variable.
        game = null;
        //Clear puzzle div and show error message.
        document.querySelector('#puzzle').innerHTML = '';
        const pTag = document.createElement("p");
        pTag.classList.add("hangman-error");
        pTag.innerText =
            'Error retrieving puzzle  Please try ' +
            'again later and see technical notes below.';
        document.querySelector('#puzzle')
            .appendChild(pTag);
        document.querySelector('#remaining_guesses')
            .textContent = '' + error;
    }
}

//Add function to reset button.
document.querySelector('#reset').addEventListener('click',
    startGame);

//Add function to "Show Answer" button.
document.querySelector('#show_answer').addEventListener('click', 
    () => {
    //Check for error state.
    if (!game) {
        return;
    }
    
    game.surrender();
    updateDom();
});

//Add function to check for key presses.
window.addEventListener('keypress', (e) => {
    //Check for error state.
    if (!game) {
        return;
    }
    
    const guess = e.key;
    game.makeGuess(guess);
    updateDom();
});

//Start game on page load.
startGame();